import ControllerBase from '../../../../global/js/ControllerBase';
import { fromEvent, Subject } from 'rxjs';
import { AtomButtonEvents } from './a-button.events';
import { takeUntil } from 'rxjs/operators';
import { ControllerUnmount } from 'global/interfaces/controller.interface';
import { fi } from 'date-fns/locale';

export default class ControllerButton extends ControllerBase implements ControllerUnmount {
	/** A list of dom element references available to this component */
	private readonly componentRefs = {
		buttonClick: 'buttonClick',
	};

	/** Subscription management */
	private _unsubscribeAll: Subject<any>;
	private isSpinning;
	private spinner;

	constructor(element: HTMLElement) {
		super(element);

		// handle subscriptions
		this._unsubscribeAll = new Subject();

		const dataDownload = this.$element.getAttribute('data-download');
		if (dataDownload && dataDownload === "share") this.share();

		// watch for button clicks
		this.observeButtonClick();
	}

	private share() {
		this.$element.addEventListener('click', () => {
			const windowNavigator = window.navigator;
			const windowUrl = this.$element.getAttribute('href') || window.location.href || undefined;
			const title = document.head?.querySelector('title')?.textContent || `Share page: ${windowUrl}`;
			const copy = document.querySelector('.m-job-ad .a-copy') as HTMLElement;
			let text = '';
			if (copy) {
				const pos = copy.innerText.indexOf("Deine Tätigkeiten");
				text = copy.innerText.substr(pos > 0 ? pos : 0);
				const pos2 = text.indexOf('Dein Profil');
				if (pos2 > 0) {
					text = text.substr(0, pos2);
				} else {
					text = text.substr(0, 1000);
				}
			} else {
				text = document.head?.querySelector('meta[name="description"]')?.getAttribute('content') || `Check page:${windowUrl}`;
			}
			const shareData = {
				title,
				text,
				url: windowUrl,
				file: []
			};
			if (windowNavigator && windowNavigator.share) {
				windowNavigator
					.share(shareData)
					.then(() => console.info('Successful share'))
					.catch((error) => console.error('Error sharing', error));
			} else {
				if (shareData?.url !== undefined) {
					alert('Successfully copied to clipboard!');
					windowNavigator.clipboard.writeText(shareData?.url);
				}
			}
		});
	}

	/**
	 * Observe button clicks
	 */
	private observeButtonClick(): void {
		fromEvent(this.$element, 'click')
			.pipe(takeUntil(this._unsubscribeAll))
			.subscribe((e: Event | MouseEvent) => this.dispatchCustomEvent(AtomButtonEvents.buttonClicked, e))
		this.$element.addEventListener('click', () => this.spinnerHandler())
	}

	public onControllerUnmount(): void {
		// remove subscribers
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}

	private spinnerHandler(): void {
		this.spinner = this.$element.getAttribute('data-spinner');
		if (this.spinner === 'true') {
			this.$element.setAttribute('data-is-spinning', 'true');
			this.isSpinning = this.$element.getAttribute('data-is-spinning');
			if (this.isSpinning) setTimeout(() => this.$element.setAttribute('data-is-spinning', 'false'), 30000);
		}
	}
}

